import { render } from "./AddEventoModal.vue?vue&type=template&id=2de9079a"
import script from "./AddEventoModal.vue?vue&type=script&lang=js"
export * from "./AddEventoModal.vue?vue&type=script&lang=js"

import "./AddEventoModal.vue?vue&type=style&index=0&id=2de9079a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__